import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";

var getProperty = function getProperty(theme, path) {
  var variantPath = Array.isArray(path) ? path[0] : path;
  var pathToProperty = variantPath === null || variantPath === void 0 ? void 0 : variantPath.split(".");
  return pathToProperty.slice(0).reduce( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  function (value, step, index, array) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    var currentStep = value[step];
    var isValue = ["function", "string", "number"].includes(currentStep);

    if (!currentStep || isValue) {
      array.splice(1);
    }

    if (currentStep) {
      return currentStep;
    }

    return null;
  }, theme);
};

export default getProperty;